<p>assignment-detail works!</p>
